export default function UpIcon({ className = "h-6 w-6" }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 4L10.5303 3.46967L10 2.93934L9.46967 3.46967L10 4ZM18 20.75C18.4142 20.75 18.75 20.4142 18.75 20C18.75 19.5858 18.4142 19.25 18 19.25L18 20.75ZM15.5303 8.46967L10.5303 3.46967L9.46967 4.53033L14.4697 9.53033L15.5303 8.46967ZM9.46967 3.46967L4.46967 8.46967L5.53033 9.53033L10.5303 4.53033L9.46967 3.46967ZM9.25 4L9.25 14L10.75 14L10.75 4L9.25 4ZM16 20.75L18 20.75L18 19.25L16 19.25L16 20.75ZM9.25 14C9.25 17.7279 12.2721 20.75 16 20.75L16 19.25C13.1005 19.25 10.75 16.8995 10.75 14L9.25 14Z"
        fill="currentColor"
      />
    </svg>
  );
}
